import classNames from "classnames";
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { styles as spotlightStyles } from "../../utils/spotlight";

import componentStyles from "./ephesians-literary-design.css";

@customElement("bp-ephesians-literary-design")
export class EphesiansLiteraryDesign extends LitElement {
  static styles = [spotlightStyles, componentStyles];

  @property({ attribute: "data" })
  data?: string;

  @property({ type: Boolean, attribute: "debug" })
  debug?: boolean;

  @property({ attribute: "title" })
  designTitle?: string;

  @property()
  reference: string | undefined;

  get annotatedHtml() {
    let result = this.data ?? "";
    result = this.annotateTags("group", result);
    result = this.annotateTags("group-title", result);
    result = result?.replace("<bp-mark", "<bp-mark can-spotlight ");

    return result;
  }

  annotateTags(tagName: string, html: string) {
    let count = 1;
    const regexp = new RegExp(`<([^>]*)class="${tagName}"([^>]*)>`, "g");

    return html.replace(regexp, (_match, p1, p2) => {
      let value = `<${p1}class="${tagName}" data-id="${tagName}-${count}"${p2}>`;

      if (this.debug) {
        value += `<div class="group-debug-label">Id: ${tagName}-${count}</div>`;
      }
      count += 1;

      return value;
    });
  }

  render() {
    if (!this.data) return;
    const classes = classNames({ debug: this.debug });

    return html`<div class="${classes}">
      ${this.designTitle
        ? html`<div class="title">${this.designTitle}</div>`
        : null}
      ${this.reference
        ? html`<div class="reference">${this.reference}</div>`
        : null}
      <div class="design">${unsafeHTML(this.annotatedHtml)}</div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-ephesians-literary-design": EphesiansLiteraryDesign;
  }
}
